const destinations = [
  {
    name: "Mexico (Cabo, Puerto Vallarta, Mexico City)",
    context: "Scottsdale residents book luxury resort trips to Los Cabos, Riviera Maya, and Mexico City on short notice — especially via PHX nonstops",
    urgency: "Last-minute luxury resort bookings happen 1–3 weeks out",
    icon: "ri-map-pin-2-line",
  },
  {
    name: "Italy & France",
    context: "European river cruises, Concours d\u2019Elegance in France, fine art and wine tourism, and Mayo Clinic physician conference travel",
    urgency: "Medical conferences and auction events have fixed, non-negotiable dates",
    icon: "ri-map-pin-2-line",
  },
  {
    name: "Japan",
    context: "Barrett-Jackson collector auctions in Japan, automotive Concours events, corporate technology partnerships, and Mayo Clinic research collaborations",
    urgency: "Auction calendars and research symposia book 4–8 weeks in advance",
    icon: "ri-map-pin-2-line",
  },
  {
    name: "United Kingdom",
    context: "Goodwood Revival and Festival of Speed, London financial meetings, and HonorHealth/Mayo Clinic physician CME programs",
    urgency: "Executive travel and collector event tickets are often booked 3–6 weeks ahead",
    icon: "ri-map-pin-2-line",
  },
  {
    name: "Canada",
    context: "Winter sports at Whistler and Banff, corporate mergers and acquisitions meetings in Toronto and Vancouver, NHL winter classics",
    urgency: "Winter peak bookings surge November through February",
    icon: "ri-map-pin-2-line",
  },
  {
    name: "Caribbean & Europe Cruises",
    context: "Scottsdale retirees and snowbirds book European river cruises and Caribbean sailings — and frequently discover passport issues within weeks of departure",
    urgency: "Retiree cruise bookings often occur 3–8 weeks before departure during promotional windows",
    icon: "ri-map-pin-2-line",
  },
];

const stats = [
  { stat: "370+ mi", label: "to the LA Passport Agency from Scottsdale — we eliminate that trip" },
  { stat: "2–4 Wks", label: "average lead time when Scottsdale executives book international trips" },
  { stat: "$500K+", label: "median home value in the Scottsdale market — travelers who expect premium service" },
  { stat: "24 hrs", label: "fastest turnaround available for genuine Scottsdale emergency cases" },
];

export default function ScottsdaleDestinationsSection() {
  return (
    <section className="bg-white py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Local Travel Intelligence</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            Where Scottsdale Travelers Go — And Why Passports Get Urgent
          </h2>
          <p className="text-gray-500 max-w-2xl mx-auto text-base leading-relaxed">
            These are the destinations and travel patterns we see most from Northeast Phoenix metro clients. Understanding local travel behavior is part of why our document review catches issues before they derail your luxury resort trip, medical conference, or automotive auction.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 mb-14">
          {stats.map((s, i) => (
            <div key={i} className="bg-[#1A365D] rounded-lg p-6 text-center">
              <p className="font-serif text-3xl font-bold text-[#F6C344] mb-2">{s.stat}</p>
              <p className="text-white/60 text-xs leading-relaxed">{s.label}</p>
            </div>
          ))}
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 mb-12">
          {destinations.map((d, i) => (
            <div key={i} className="bg-[#F7F8FA] rounded-lg p-6 border border-gray-200 hover:border-[#F6C344] transition-all group">
              <div className="flex items-center gap-3 mb-4">
                <div className="w-10 h-10 flex items-center justify-center rounded-full bg-[#1A365D]/5 group-hover:bg-[#F6C344]/15 transition-colors flex-shrink-0">
                  <i className={`${d.icon} text-[#1A365D] group-hover:text-[#F6C344] transition-colors text-lg`}></i>
                </div>
                <h3 className="font-bold text-[#1A365D] text-sm">{d.name}</h3>
              </div>
              <p className="text-gray-500 text-sm leading-relaxed mb-3">{d.context}</p>
              <div className="flex items-start gap-2">
                <i className="ri-time-line text-[#F6C344] text-xs flex-shrink-0 mt-0.5"></i>
                <p className="text-gray-400 text-xs leading-relaxed italic">{d.urgency}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="bg-[#F7F8FA] rounded-lg p-6 border border-gray-200">
          <div className="flex flex-col md:flex-row items-start md:items-center gap-4">
            <div className="w-12 h-12 flex items-center justify-center rounded-full bg-[#1A365D]/5 flex-shrink-0">
              <i className="ri-links-line text-[#1A365D] text-xl"></i>
            </div>
            <div className="flex-1">
              <h3 className="font-bold text-[#1A365D] text-sm mb-1">Explore Other Arizona Service Areas</h3>
              <p className="text-gray-500 text-sm leading-relaxed">
                We serve travelers across Arizona with the same expedited passport processing and document review expertise. Looking for service in another community?
              </p>
            </div>
            <div className="flex flex-wrap gap-2 flex-shrink-0">
              <a href="/cities/phoenix" className="inline-flex items-center gap-1.5 bg-white hover:bg-[#1A365D] text-[#1A365D] hover:text-white border border-gray-200 hover:border-[#1A365D] font-medium text-xs px-3.5 py-2 rounded-md transition-all whitespace-nowrap">
                Phoenix <i className="ri-arrow-right-line text-xs"></i>
              </a>
              <a href="/cities/mesa" className="inline-flex items-center gap-1.5 bg-white hover:bg-[#1A365D] text-[#1A365D] hover:text-white border border-gray-200 hover:border-[#1A365D] font-medium text-xs px-3.5 py-2 rounded-md transition-all whitespace-nowrap">
                Mesa <i className="ri-arrow-right-line text-xs"></i>
              </a>
              <a href="/cities/tucson" className="inline-flex items-center gap-1.5 bg-white hover:bg-[#1A365D] text-[#1A365D] hover:text-white border border-gray-200 hover:border-[#1A365D] font-medium text-xs px-3.5 py-2 rounded-md transition-all whitespace-nowrap">
                Tucson <i className="ri-arrow-right-line text-xs"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}